import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';

import { ConfigService } from '../../services/config/config.service';
import { UsageReport } from '../../services/usage-reports/usage-report.model';
import { UsageReportsService } from '../../services/usage-reports/usage-reports.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';

@Component({
    selector: 'app-usage-reports',
    templateUrl: './usage-reports.component.html',
    styleUrls: ['./usage-reports.component.css']
})
export class UsageReportsComponent implements OnInit {
    usageReports: UsageReport[];

    constructor(
        private usageReportsService: UsageReportsService,
        private returnUrlService: ReturnUrlService,
        private configService: ConfigService
    ) {
        this.returnUrlService.save();
    }

    getUsageReportUrl(usageReport: UsageReport): string {
        const params = `councilId=${usageReport.councilId}&year=${usageReport.year}&month=${usageReport.month}`;
        return `${this.configService.config.apiRoot}usagereport?${params}`;
    }

    async downloadReport(usageReport: UsageReport): Promise<void> {
        const reportFile = await this.usageReportsService.getReportContent(usageReport);
        saveAs(reportFile, `${usageReport.name} ${usageReport.year} ${usageReport.month}.csv`);
    }

    async ngOnInit(): Promise<void> {
        this.usageReports = await this.usageReportsService.all();
    }
}
